const INSTALLATION_ID_KEY = "brian.softphone.installationId";
const ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

let sessionInstallationId: string | null = null;

/** brian keys the browser endpoint on this, so two computers on one account never share one. */
export const getInstallationId = (): string => {
  try {
    const existing = localStorage.getItem(INSTALLATION_ID_KEY);
    if (existing && ID_PATTERN.test(existing)) return existing;
    const minted = crypto.randomUUID();
    localStorage.setItem(INSTALLATION_ID_KEY, minted);
    return minted;
  } catch {
    sessionInstallationId ??= crypto.randomUUID();
    return sessionInstallationId;
  }
};
